<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="member-dialog"
    @close="handleClose"
    @open="openDialog"
    :show-close="false"
  >
    <!-- 顶部关闭按钮 -->
    <div class="dialog-close" @click="handleClose">
      <i style="font-size: 26px; color: #ffffff" class="el-icon-close" />
    </div>
    <div v-loading="loading" element-loading-text="加载会员信息中..." class="dialog-container">
      <!-- 左侧：用户信息 -->
      <div class="user-section">
        <div class="user-info">
          <img
            src="@/assets/image/portrait.jpg"
            alt="用户头像"
            class="user-avatar"
          />
          <div class="username">{{ userName }}</div>
        </div>
        <div class="user-tags">
          <span class="tag">会员ID: {{ memberID }}</span>
          <span class="tag">当前身份: {{ memberIdentity }}</span>
          <span class="tag">到期时间: {{ expireLabel }}</span>
        </div>
      </div>
      <div class="conter">
        <div class="tabs">
          <div
            class="tabs-item"
            @click="tabsActive = 1"
            :class="{ active: tabsActive === 1 }"
          >
            个人版
          </div>
          <div
            class="tabs-item"
            @click="tabsActive = 2"
            :class="{ active: tabsActive === 2 }"
          >
            团队版
          </div>
        </div>
        <div class="tab">
          <div class="tab-item" :class="{ active: activeTab === 'membership' }" @click="activeTab = 'membership'">开通会员</div>
          <div class="tab-item" :class="{ active: activeTab === 'credits' }" @click="activeTab = 'credits'">购买积分包</div>
        </div>
        <div class="member-cards">
          <div
            class="member-card"
            :class="{ active: index === carActive }"
            v-for="(item, index) in displayPlans"
            :key="item.code || index"
            @click="carActive = index"
          >
            <img
              v-if="index === carActive"
              class="subscript"
              src="@/assets/image/subscript.png"
              alt=""
            />
            <div class="card-title">{{ item.title }}</div>
            <div class="card-price"><span>¥</span>{{ planDisplayPrice(item) }}</div>
            <div class="card-origin" :class="{ active: index === carActive }">
              原价: {{ item.originalPriceLabel }}
            </div>
            <div v-if="item.metaType !== 'number' && !compactBenefits" class="card-origin" :class="{ active: index === carActive }">
              {{ item.creditsText || "当前套餐无赠送积分" }}
            </div>
            <div v-if="activeTab === 'membership' && compactBenefits" class="card-benefits compact-member-benefits">
              <div class="card-benefits-heading">
                <span class="card-benefits-title">会员权益</span>
                <el-popover placement="bottom" trigger="click" popper-class="video-membership-benefits-popover">
                  <div class="benefits-popover-title">{{ item.title }} · 全部权益</div>
                  <div class="benefits-popover-credit">{{ item.creditsText || '当前套餐无赠送积分' }}</div>
                  <ul class="benefits-popover-list">
                    <li v-for="(benefit, benefitIndex) in item.benefits" :key="benefitIndex">{{ benefit }}</li>
                  </ul>
                  <div v-if="!item.benefits || !item.benefits.length">暂无权益说明</div>
                  <button slot="reference" type="button" class="benefits-detail-trigger" @click.stop>查看全部<i class="el-icon-arrow-right" aria-hidden="true" /></button>
                </el-popover>
              </div>
              <div class="benefits-summary-row" :title="item.creditsText">{{ item.creditsText || '当前套餐无赠送积分' }}</div>
              <div class="benefits-summary-row" :title="item.benefits && item.benefits[0]">{{ item.benefits && item.benefits[0] || '暂无权益说明' }}</div>
            </div>
            <div v-else-if="activeTab === 'membership'" class="card-benefits" :class="{ active: index === carActive }">
              <div class="card-benefits-title">会员权益</div>
              <div class="card-benefits-list">
                <div
                  v-for="benefit in item.benefits"
                  :key="benefit"
                  class="card-benefit"
                >
                  {{ benefit }}
                </div>
                <div v-if="!item.benefits || !item.benefits.length" class="card-benefit empty">暂无权益说明</div>
              </div>
            </div>
            <div v-else class="card-benefits credit-package-details" :class="{ active: index === carActive }">
              <div class="card-benefits-title">积分包说明</div>
              <div class="credit-package-row"><span>到账积分</span><strong>{{ item.credits }}</strong></div>
              <div class="credit-package-row"><span>有效期</span><strong>{{ item.validity }}</strong></div>
            </div>
            <div class="card-btn" :class="{ active: index === carActive }">
              {{ item.benefitText }}
            </div>
            <div v-if="item.hot" class="merberTag">{{ item.benefitText }}</div>
            <div
              class="card-footer"
              v-if="activeTab === 'membership' && item.billing_cycle === 'lifetime' && saleDeadlineLabel"
              :class="{ active: index === carActive, expired: !saleDeadlineActive }"
            >
              {{ saleFooterText }}
            </div>
          </div>
        </div>

        <!-- 支付区域 -->
        <div class="payment-section">
          <div class="qrcode-box">
            <canvas
              v-show="paymentQRCodeReady"
              ref="paymentQRCodeCanvas"
              class="qrcode-canvas"
            />
            <div v-if="paymentLoading" class="qrcode-loading">生成中...</div>
            <div v-if="!paymentQRCodeReady && !paymentLoading" class="qrcode-mask">
              <div class="qrcode-mask-title">{{ qrHintTitle }}</div>
              <div class="qrcode-mask-text">{{ qrHintText }}</div>
            </div>
          </div>
          <div class="payment-info">
            <div style="width: 50%">
              <div class="total-price">
                <span>应付金额:</span>
                <span class="price"><span>¥</span>{{ selectedPlanDisplayPrice }}</span>
                <span>元</span>
                <div v-if="totalDiscount > 0" class="payment-tag payment-tags">历史最低价</div>
                <div class="payment-tag">可开发票</div>
              </div>

              <div class="payment-methods">
                <div
                  class="method-item"
                  :class="{ active: payChannel === 'alipay', disabled: !selectedPlan.id }"
                  @click="handlePayChannelSelect('alipay')"
                >
                  <img
                    src="@/assets/image/alipay.png"
                    alt=""
                    class="method-icon"
                  />
                  <span>支付宝支付</span>
                  <svg-icon name="alipay-sele" class="sele" />
                </div>
                <div
                  class="method-item"
                  :class="{ active: payChannel === 'wechat', disabled: !selectedPlan.id }"
                  @click="handlePayChannelSelect('wechat')"
                >
                  <img
                    src="@/assets/image/wechat.png"
                    alt=""
                    class="method-icon"
                  />
                  <span>微信支付</span>
                  <svg-icon name="wechat-sele" class="sele" />
                </div>
              </div>

              <div class="privacy">
                <el-checkbox v-model="privacyAccepted" @change="handlePrivacyChange"></el-checkbox>
                同意并阅读《用户隐私条款》
              </div>
              <div class="payment-auto-tip">
                选择套餐与支付方式后，将自动生成支付二维码
              </div>
              <div v-if="paymentCreateError" class="payment-create-error" role="alert">
                <span>{{ paymentCreateError }}</span>
                <el-button v-if="!paymentOrderNo" type="text" :loading="paymentLoading" @click="startPayment()">重新生成支付二维码</el-button>
              </div>
              <div v-if="selectedPlanDescription" class="selected-plan-description">
                {{ selectedPlanDescription }}
              </div>
            </div>
            <div class="discount">
              <div class="discount-top">
                <div class="discount-price">已优惠{{ totalDiscount }}元</div>
                <div class="discount-warn">{{ discountWarnText }}</div>
              </div>
              <div v-if="activeTab === 'membership' && promotionCards.length >= 3" class="discount-tag">
                <div
                  v-for="item in promotionCards.slice(0, 2)"
                  :key="item.code"
                  class="left"
                  :class="{ expired: item.expired }"
                >
                  <div class="tag-price"><span>¥</span> {{ item.amount }}</div>
                  <div class="tag-title">{{ item.title }}</div>
                </div>
                <div class="right promo-card-main" :class="{ expired: promotionCards[2].expired }">
                  <div class="tag-price"><span>¥</span> {{ promotionCards[2].amount }}</div>
                  <div class="tag-title">{{ promotionCards[2].title }}</div>
                  <div v-if="promotionCards[2].statusText" class="tag-title">{{ promotionCards[2].statusText }}</div>
                </div>
              </div>
              <div v-else-if="activeTab === 'membership' && promotionCards.length === 2" class="discount-tag discount-tag2">
                <div class="left" :class="{ expired: promotionCards[0].expired }">
                  <div class="tag-price"><span>¥</span> {{ promotionCards[0].amount }}</div>
                  <div class="tag-title">{{ promotionCards[0].title }}</div>
                </div>
                <div class="right" :class="{ expired: promotionCards[1].expired }">
                  <div class="tag-price"><span>¥</span> {{ promotionCards[1].amount }}</div>
                  <div class="tag-title">{{ promotionCards[1].title }}</div>
                  <div v-if="promotionCards[1].statusText" class="tag-title">{{ promotionCards[1].statusText }}</div>
                </div>
              </div>
              <div v-else-if="activeTab === 'membership' && promotionCards.length === 1" class="discount-tag discount-tag2">
                <div class="left" :class="{ expired: promotionCards[0].expired }">
                  <div class="tag-price"><span>¥</span> {{ promotionCards[0].amount }}</div>
                  <div class="tag-title">{{ promotionCards[0].title }}</div>
                </div>
                <div class="right" :class="{ expired: promotionCards[0].expired }">
                  <div v-if="promotionCards[0].statusText" class="tag-price">{{ promotionCards[0].statusText }}</div>
                  <div v-else class="tag-price">{{ promotionCards[0].title }}</div>
                </div>
              </div>
              <div v-else class="discount-tag discount-tag2">
                <div class="right" style="width: 100%">
                  <div class="tag-price">{{ activeTab === "membership" ? "当前暂无可用优惠" : "积分加油包按后台价格展示" }}</div>
                  <div class="tag-title">{{ selectedPlan.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部说明 -->
      <div class="footer-note">
        <div>
          <img
            src="@/assets/image/prompt.png"
            style="width: 16px; height: 16px"
            alt=""
          />
          <div>{{ activeTab === 'membership' ? '会员权益' : '积分包说明' }}: <span class="benefits-link-placeholder">查看套餐卡片了解详情</span></div>
        </div>
        <div>
          <img
            style="width: 23px; height: 18px"
            src="@/assets/image/email.png"
            alt=""
          />
          <div>
            感谢语: 感谢<span>用户ID {{ memberID }}</span>在 2026-01-01 12: 00 成功
            <span> 升级为 {{ selectedPlan.title }} </span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcode";
import { createPayment, getPaymentStatus } from "@/services/payment";
import {
  PAYMENT_FLOW_PHASE,
  classifyPaymentOrder,
  isCurrentPaymentResponse,
  isNewPaymentSuccess,
} from "@/services/paymentStatus";
import { refreshMyPaymentOrders } from "@/services/myPaymentOrders";
import { formatYuanFromCents } from "@/utils/currency";

function normalizePromotionCyclesByEdition(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    personal: Array.isArray(source.personal) ? Array.from(new Set(source.personal.filter(Boolean))) : [],
    team: Array.isArray(source.team) ? Array.from(new Set(source.team.filter(Boolean))) : [],
  };
}

export default {
  name: "member-dialog",
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    compactBenefits: { type: Boolean, default: false },
    keepOpenOnClose: { type: Boolean, default: false },
    userName: { type: String, default: "未登录用户" },
    memberID: { type: [String, Number], default: "--" },
    memberIdentity: { type: String, default: "普通用户" },
    memberLevelCode: { type: String, default: "free" },
    expireLabel: { type: String, default: "未开通" },
    plans: { type: Array, default: () => [] },
    creditPackages: { type: Array, default: () => [] },
    discounts: { type: Array, default: () => [] },
    promotionCards: { type: Array, default: () => [] },
    stage3Active: { type: Boolean, default: false },
    stage3CountdownLabel: { type: String, default: "00:00:00" },
    stage3Expired: { type: Boolean, default: false },
    saleDeadlineLabel: { type: String, default: "" },
    saleCountdownLabel: { type: String, default: "00:00:00" },
    saleDeadlineActive: { type: Boolean, default: false },
  },
  data() {
    return {
      carActive: 0,
      tabsActive: 1,
      activeTab: "membership",
      closeReason: "",
      payChannel: "",
      privacyAccepted: true,
      paymentLoading: false,
      paymentCreateError: "",
      paymentQRCodeReady: false,
      paymentOrderNo: "",
      paymentPollTimer: null,
      paymentPollGeneration: 0,
      paymentAutoCreateTimer: null,
      paymentRequestKey: "",
      paymentRequestGeneration: 0,
      paymentFlowPhase: PAYMENT_FLOW_PHASE.IDLE,
      emittedPaymentSuccessOrderNos: new Set(),
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    currentAudience() {
      return this.tabsActive === 1 ? "personal" : "team";
    },
    displayPlans() {
      const source = this.activeTab === "membership" ? this.plans : this.creditPackages;
      return source.filter((item) => item.audience === this.currentAudience).slice(0, 5);
    },
    selectedPlan() {
      return this.displayPlans[this.carActive] || this.displayPlans[0] || {
        title: this.activeTab === "membership" ? "会员套餐" : "积分加油包",
        currentPrice: 0,
        currentPriceCents: 0,
        originalPrice: 0,
        originalPriceCents: 0,
        credits: 0,
        validity: "-",
        benefitText: "",
        billing_cycle: "",
        audience: this.currentAudience,
        applicableEditions: [],
        applicableBillingCycles: [],
      };
    },
    applicableDiscounts() {
      if (this.activeTab !== "membership" || !this.selectedPlan || !this.selectedPlan.id) {
        return [];
      }
      return this.resolveApplicableDiscounts(this.selectedPlan);
    },
    totalDiscount() {
      return formatYuanFromCents(this.totalDiscountCents);
    },
    totalDiscountCents() {
      return this.applicableDiscounts.reduce((sum, item) => sum + Number(item.amountCents || Math.round(Number(item.amount || 0) * 100)), 0);
    },
    selectedPlanDisplayPrice() {
      return this.planDisplayPrice(this.selectedPlan);
    },
    selectedPlanDescription() {
      return String(this.selectedPlan && this.selectedPlan.description || "").trim();
    },
    discountWarnText() {
      if (this.activeTab !== "membership") {
        return "积分加油包当前未接入专属优惠";
      }
      return this.totalDiscountCents > 0 ? "当前可用优惠按账号状态自动抵扣" : "当前套餐按后台价格展示";
    },
    saleFooterText() {
      if (!this.saleDeadlineLabel) {
        return "";
      }
      if (this.saleDeadlineActive) {
        return `会员优惠将于 ${this.saleCountdownLabel} 失效`;
      }
      return `会员优惠已失效`;
    },
    qrHintTitle() {
      if (!this.selectedPlan || !this.selectedPlan.id) {
        return "暂无可支付套餐";
      }
      if (!this.payChannel) {
        return "请选择支付渠道";
      }
      if (!this.privacyAccepted) {
        return "请先勾选隐私条款";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.CONFIRMING) {
        return "支付结果确认中";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.FULFILLING) {
        return "支付已确认";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.MANUAL_REVIEW) {
        return "订单待人工核对";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.FAILED) {
        return "订单已关闭";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.UNKNOWN) {
        return "订单状态确认中";
      }
      return "等待生成支付二维码";
    },
    qrHintText() {
      if (!this.selectedPlan || !this.selectedPlan.id) {
        return "当前分类暂未配置可购买套餐";
      }
      if (!this.payChannel) {
        return "已为你默认选中推荐套餐，请继续选择微信或支付宝";
      }
      if (!this.privacyAccepted) {
        return "请先勾选用户隐私条款";
      }
      if (this.paymentLoading) {
        return "正在生成当前订单二维码";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.CONFIRMING) {
        return "正在向支付渠道核实结果，请勿重复支付";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.FULFILLING) {
        return "权益正在到账，请稍候";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.MANUAL_REVIEW) {
        return "请勿重复支付，请联系客服处理";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.FAILED) {
        return "可重新选择套餐或支付方式";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.UNKNOWN) {
        return "正在核实当前订单，请稍候";
      }
      if (this.paymentFlowPhase === PAYMENT_FLOW_PHASE.PENDING && !this.paymentQRCodeReady) {
        return "正在获取当前订单二维码";
      }
      return "已根据当前选择自动生成专属支付二维码";
    },
  },
  watch: {
    tabsActive() {
      this.carActive = this.recommendedPlanIndex();
      this.payChannel = "";
      this.resetPaymentState();
    },
    activeTab() {
      this.carActive = this.recommendedPlanIndex();
      this.payChannel = "";
      this.resetPaymentState();
    },
    carActive() {
      this.resetPaymentState();
      this.queueAutoCreatePayment();
    },
    payChannel() {
      this.resetPaymentState();
      this.queueAutoCreatePayment();
    },
    privacyAccepted(value) {
      if (!value) {
        this.resetPaymentState();
        return;
      }
      this.queueAutoCreatePayment();
    },
    visible(value) {
      if (value) {
        this.activeTab = "membership";
        this.carActive = this.recommendedPlanIndex();
        this.payChannel = "";
        this.privacyAccepted = true;
        this.resetPaymentState();
      } else {
        this.resetPaymentState();
      }
    },
  },

  beforeDestroy() {
    this.stopPaymentPolling();
    this.clearAutoCreateTimer();
  },

  methods: {
    openDialog() {
      setTimeout(() => {
        if (this.$bus) {
          this.$bus.$emit("openNewDialog", true);
        }
      }, 500);
    },
    handleClose() {
      const reason = String(this.closeReason || "manual").trim().toLowerCase();
      this.closeReason = "";
      this.resetPaymentState();
      if (reason === "payment_success") {
        this.$emit("closed", { reason });
        return;
      }
      if (this.keepOpenOnClose) {
        this.$emit("closed", { reason });
        return;
      }
      this.dialogVisible = false;
      this.$emit("closed", { reason });
    },
    async handlePayChannelSelect(channel) {
      if (this.loading) {
        return;
      }
      if (!this.selectedPlan || !this.selectedPlan.id) {
        return;
      }
      if (this.payChannel === channel) {
        return;
      }
      this.payChannel = channel;
    },
    async handlePrivacyChange(value) {
      if (this.loading) {
        return;
      }
      if (!value) {
        this.resetPaymentState();
        return;
      }
    },
    clearAutoCreateTimer() {
      if (this.paymentAutoCreateTimer) {
        clearTimeout(this.paymentAutoCreateTimer);
        this.paymentAutoCreateTimer = null;
      }
    },
    currentPaymentRequestKey() {
      if (!this.selectedPlan || !this.selectedPlan.id || !this.payChannel || !this.privacyAccepted) {
        return "";
      }
      return [
        this.activeTab,
        this.tabsActive,
        this.selectedPlan.id,
        this.payChannel,
      ].join(":");
    },
    queueAutoCreatePayment() {
      this.clearAutoCreateTimer();
      const requestKey = this.currentPaymentRequestKey();
      if (!requestKey || this.loading || !this.dialogVisible) {
        return;
      }
      this.paymentAutoCreateTimer = window.setTimeout(() => {
        this.paymentAutoCreateTimer = null;
        this.startPayment({ requestKey, silentConflict: true });
      }, 120);
    },
    planDisplayPrice(plan) {
      return formatYuanFromCents(this.planDisplayPriceCents(plan));
    },
    planDisplayPriceCents(plan) {
      if (!plan) {
        return 0;
      }
      if (this.activeTab !== "membership") {
        return Number(plan.currentPriceCents || Math.round(Number(plan.currentPrice || 0) * 100));
      }
      const base = Number(plan.originalPriceCents || plan.currentPriceCents || Math.round(Number(plan.originalPrice || plan.currentPrice || 0) * 100));
      const discount = this.resolveApplicableDiscounts(plan).reduce((sum, item) => sum + Number(item.amountCents || 0), 0);
      return Math.max(100, base - discount);
    },
    resolveApplicableDiscounts(plan) {
      if (!plan) {
        return [];
      }
      if (this.memberLevelCode && this.memberLevelCode !== "free") {
        return [];
      }
      return this.discounts.filter((item) => {
        const editions = Array.isArray(item.applicableEditions) ? item.applicableEditions : [];
        const currentEdition = plan.audience || this.currentAudience;
        const editionMatched = editions.length === 0 || editions.includes(currentEdition);
        const cycleMap = normalizePromotionCyclesByEdition(item.applicableCyclesByEdition);
        const hasEditionScopedCycles = cycleMap.personal.length > 0 || cycleMap.team.length > 0;
        const cycles = hasEditionScopedCycles
          ? (cycleMap[currentEdition] || [])
          : (Array.isArray(item.applicableBillingCycles) ? item.applicableBillingCycles : []);
        const cycleMatched = cycles.length === 0 || cycles.includes(plan.billing_cycle || "");
        return editionMatched && cycleMatched;
      });
    },
    async startPayment(options = {}) {
      if (this.loading || !this.selectedPlan || !this.selectedPlan.id || this.paymentLoading) {
        return;
      }
      if (!this.payChannel) {
        this.$message.warning("请选择支付渠道");
        return;
      }
      const requestKey = options.requestKey || this.currentPaymentRequestKey();
      if (!requestKey) {
        return;
      }
      if (this.paymentRequestKey === requestKey && (this.paymentQRCodeReady || this.paymentLoading || this.paymentOrderNo)) {
        return;
      }
      this.stopPaymentPolling();
      const requestGeneration = this.paymentRequestGeneration + 1;
      this.paymentRequestGeneration = requestGeneration;
      this.paymentLoading = true;
      this.paymentCreateError = "";
      this.paymentQRCodeReady = false;
      this.paymentOrderNo = "";
      this.paymentRequestKey = requestKey;
      this.clearQRCodeCanvas();
      try {
        const payload = await createPayment({
          order_type: this.activeTab === "membership" ? "membership_plan" : "credit_package",
          item_id: this.selectedPlan.id,
          pay_channel: this.payChannel,
          amount_cents: this.activeTab === "membership"
            ? Math.max(100, Number(this.selectedPlan.originalPriceCents || 0) - this.totalDiscountCents)
            : undefined,
        });
        if (requestGeneration !== this.paymentRequestGeneration || requestKey !== this.paymentRequestKey) {
          return;
        }
        const orderNo = String(payload && payload.order_no || "").trim();
        if (!orderNo) {
          throw new Error("支付订单缺少订单号，请稍后重试");
        }
        this.paymentOrderNo = orderNo;
        refreshMyPaymentOrders({ limit: 20, offset: 0 }).catch(() => {});
        const state = await this.applyPaymentPayload(payload, orderNo);
        if (state && state.shouldPoll && requestGeneration === this.paymentRequestGeneration) {
          this.startPaymentPolling();
        }
      } catch (error) {
        if (requestGeneration !== this.paymentRequestGeneration) {
          return;
        }
        this.paymentRequestKey = "";
        this.paymentCreateError = error.message || "创建支付订单失败，请重试";
        if (!(options.silentConflict && error && /409|进行中的订单|未支付订单/i.test(String(error.message || "")))) {
          this.$message.error(error.message || "创建支付订单失败");
        }
      } finally {
        if (requestGeneration === this.paymentRequestGeneration) {
          this.paymentLoading = false;
        }
      }
    },
    async renderQRCode(qrText) {
      if (!qrText || !this.$refs.paymentQRCodeCanvas) {
        this.paymentQRCodeReady = false;
        return;
      }
      await QRCode.toCanvas(this.$refs.paymentQRCodeCanvas, qrText, {
        width: 124,
        margin: 1,
      });
      this.paymentQRCodeReady = true;
    },
    clearQRCodeCanvas() {
      const canvas = this.$refs.paymentQRCodeCanvas;
      if (!canvas || !canvas.getContext) {
        return;
      }
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width || 0, canvas.height || 0);
    },
    startPaymentPolling() {
      const orderNo = String(this.paymentOrderNo || "").trim();
      if (!orderNo) {
        return;
      }
      this.stopPaymentPolling();
      const generation = this.paymentPollGeneration;
      const schedule = () => {
        this.paymentPollTimer = window.setTimeout(async () => {
          this.paymentPollTimer = null;
          if (generation !== this.paymentPollGeneration || orderNo !== this.paymentOrderNo) {
            return;
          }
          try {
            const payload = await getPaymentStatus(orderNo);
            if (generation !== this.paymentPollGeneration || orderNo !== this.paymentOrderNo) {
              return;
            }
            await this.applyPaymentPayload(payload, orderNo);
          } catch (error) {
            // Keep polling on transient errors so callback/query fallback still has time to settle the order.
          }
          if (generation === this.paymentPollGeneration && orderNo === this.paymentOrderNo) {
            schedule();
          }
        }, 3000);
      };
      schedule();
    },
    stopPaymentPolling() {
      this.paymentPollGeneration += 1;
      if (this.paymentPollTimer) {
        clearTimeout(this.paymentPollTimer);
        this.paymentPollTimer = null;
      }
    },
    resetPaymentState() {
      this.paymentRequestGeneration += 1;
      this.clearAutoCreateTimer();
      this.stopPaymentPolling();
      this.paymentLoading = false;
      this.paymentCreateError = "";
      this.paymentQRCodeReady = false;
      this.paymentOrderNo = "";
      this.paymentRequestKey = "";
      this.paymentFlowPhase = PAYMENT_FLOW_PHASE.IDLE;
      this.clearQRCodeCanvas();
    },
    async applyPaymentPayload(payload, expectedOrderNo = this.paymentOrderNo) {
      const payloadOrderNo = String(payload && payload.order_no || "").trim();
      const currentOrderNo = String(this.paymentOrderNo || "").trim();
      if (!isCurrentPaymentResponse(expectedOrderNo, currentOrderNo, payload)) {
        return null;
      }
      const previousPhase = this.paymentFlowPhase;
      const state = classifyPaymentOrder(payload);
      const shouldEmitSuccess = isNewPaymentSuccess(this.emittedPaymentSuccessOrderNos, payload);
      this.paymentFlowPhase = state.phase;

      if (state.showQRCode) {
        await this.renderQRCode(payload && payload.qrcode || "");
        if (expectedOrderNo !== this.paymentOrderNo) {
          this.paymentQRCodeReady = false;
          this.clearQRCodeCanvas();
          return null;
        }
      } else {
        this.paymentQRCodeReady = false;
        this.clearQRCodeCanvas();
      }

      if (state.isSuccess) {
        this.stopPaymentPolling();
        if (!shouldEmitSuccess) {
          return state;
        }
        this.emittedPaymentSuccessOrderNos.add(payloadOrderNo);
        refreshMyPaymentOrders({ limit: 20, offset: 0 }).catch(() => {});
        this.$message.success("支付成功");
        this.$emit("payment-success", payload);
        this.closeReason = "payment_success";
        this.dialogVisible = false;
        return state;
      }

      if (state.phase === PAYMENT_FLOW_PHASE.MANUAL_REVIEW) {
        this.stopPaymentPolling();
        refreshMyPaymentOrders({ limit: 20, offset: 0 }).catch(() => {});
        if (previousPhase !== PAYMENT_FLOW_PHASE.MANUAL_REVIEW) {
          this.$message.warning(this.paymentFailureMessage(payload));
        }
        return state;
      }

      if (state.phase === PAYMENT_FLOW_PHASE.FAILED) {
        this.stopPaymentPolling();
        this.paymentRequestKey = "";
        refreshMyPaymentOrders({ limit: 20, offset: 0 }).catch(() => {});
        if (previousPhase !== PAYMENT_FLOW_PHASE.FAILED) {
          this.$message.warning(this.paymentFailureMessage(payload));
        }
      }
      return state;
    },
    paymentFailureMessage(payload) {
      const status = String(payload && payload.status || "").trim().toLowerCase();
      const closeReason = String(payload && payload.close_reason || "").trim().toLowerCase();
      const errorMessage = String(payload && payload.error_message || "").trim();
      if (status === "reconciliation_required") {
        return "订单支付结果需要人工核对，请勿重复支付并联系客服处理";
      }
      if (errorMessage) {
        return errorMessage;
      }
      if (closeReason === "expired") {
        return "订单已超时关闭，请重新生成支付二维码";
      }
      if (status === "rejected") {
        return "订单已关闭，请重新生成支付二维码";
      }
      if (status === "failed") {
        return "支付下单失败，请重新尝试";
      }
      return "支付未完成，请重新尝试";
    },
    recommendedPlanIndex() {
      const items = this.displayPlans || [];
      if (!items.length) {
        return 0;
      }
      const hotIndex = items.findIndex((item) => item && item.hot);
      return hotIndex >= 0 ? hotIndex : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 隐藏原生头部 */
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .el-dialog {
  border-radius: 12px !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
/* 关闭按钮 */
.dialog-close {
  position: absolute;
  top: -24px;
  right: -30px;
  z-index: 10;
  cursor: pointer;
  .close-icon {
    width: 24px;
    height: 24px;
    background: #fff;
    border-radius: 50%;
  }
}

/* 主容器 */
.dialog-container {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}
.conter {
  height: 570px;
  background-image: linear-gradient(
    -34deg,
    #ffeade 0%,
    #fffdf5 35%,
    #ffffff 100%
  );
}
/* 顶部用户信息 */
.user-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  height: 70px;
  background-image: url("@/assets/image/vip-top-bg.jpg");
  background-size: cover;
  .user-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 11px;
    margin-left: 40px;
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e5e5e5;
  }
  .username {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
  }

  .user-tags {
    margin-right: 44px;
    display: flex;
    gap: 44px;
    font-size: 14px;
    color: #ffffff;
  }
}

/* Tab 切换 */
.tabs {
  display: flex;
  margin-bottom: 20px;
  height: 36px;
  background-color: #e9eef4;
  margin: 14px 35px 14px;
  border-radius: 17px;
  .tabs-item {
    width: 50%;
    text-align: center;
    font-size: 18px;
    line-height: 36px;
    color: #666666;
    cursor: pointer;
    border-radius: 17px;
    &.active {
      color: #ffffff;
      background-image: linear-gradient(90deg, #333333 0%, #898989 100%);
    }
  }
}
.tab {
  display: flex;
  margin-bottom: 20px;
  height: 40px;
  .tab-item {
    text-align: center;
    font-size: 18px;
    line-height: 40px;
    color: #666666;
    position: relative;
    cursor: pointer;
    margin-left: 60px;
    &.active {
      color: #333333;
    }
    &.active::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 37px;
      height: 3px;
      background-color: #ff7d00;
      border-radius: 3px;
    }
  }
}

/* 会员卡片列表 */
.member-cards {
  // 分成五等分
  display: flex;
  gap: 20px; // 卡片之间的间距
  padding: 0 50px; // 左右内边距
  margin-bottom: 25px;
}

/* 单个会员卡片 */
.member-card {
  height: 230px;
  width: 100%;
  background: url("@/assets/image/individual.jpg");
  background-repeat: no-repeat; /* 不重复 */
  background-size: 100% 100%; /* 宽高铺满拉伸 */
  background-position: center; /* 居中 */
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s;
  border: solid 1px #e6e6e6;
  cursor: pointer;
  .subscript {
    width: 44px;
    height: 38px;
    position: absolute;
    top: 0;
    right: 0;
  }
  &.active {
    background: url("@/assets/image/individual-active.jpg");
    background-repeat: no-repeat; /* 不重复 */
    background-size: 100% 100%; /* 宽高铺满拉伸 */
    background-position: center; /* 居中 */
    border: 1px solid #ff7d00;
    box-shadow: 0px 10px 20px 0px rgba(255, 115, 30, 0.3);
  }

  .card-tag {
    position: absolute;
    top: -10px;
    right: 10px;
    background: #ff7d00;
    color: #fff;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 40px;
  }

  .card-price {
    font-size: 24px;
    font-weight: 700;
    font-size: 30px;
    margin-bottom: 20px;
    margin-top: 20px;
    color: #333333;
    span {
      font-size: 16px;
      color: #333333;
    }
  }

  .card-origin {
    font-size: 14px;
    color: #999;
    line-height: 24px;
    letter-spacing: 0px;
    color: #999999;
    &.active {
      color: #333333;
      span {
        color: #ff6702;
      }
    }
  }
  .card-benefits {
    width: calc(100% - 28px);
    margin-top: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.74);
    color: #777777;
    font-size: 12px;
    line-height: 18px;
    max-height: 42px;
    overflow: hidden;
    transition: max-height 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    z-index: 2;
    &.active {
      color: #333333;
      background: rgba(255, 248, 241, 0.94);
    }
    &:hover {
      position: absolute;
      top: 132px;
      left: 14px;
      max-height: 240px;
      overflow-y: auto;
      box-shadow: 0 10px 24px rgba(255, 115, 30, 0.18);
      background: #fffaf5;
      z-index: 5;
      .card-benefit {
        white-space: normal;
      }
    }
  }
  .card-benefits-title {
    font-weight: 600;
    margin-bottom: 2px;
  }
  .card-benefit {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.empty {
      color: #aaaaaa;
    }
  }
  .merberTag {
    width: 100px;
    height: 41px;
    position: absolute;
    background-image: url("@/assets/image/merberTag.png");
    font-size: 13px;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    top: -10px;
    right: -10px;
  }
  .card-footer {
    height: 40px;
    width: 100%;
    text-align: center;
    line-height: 40px;
    position: absolute;
    left: 0;
    bottom: -40px;
    color: #ffffff;
    font-size: 14px;
    background-image: linear-gradient(
      90deg,
      rgba(255, 149, 85, 1) 0%,
      #ff4646 100%
    );
    &.expired {
      background-image: linear-gradient(90deg, #9f9f9f 0%, #727272 100%);
    }
  }
  .card-btn {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #aaaaaa;

    &.active {
      color: #333333;
    }
  }
}

.selected-plan-description {
  margin-top: 8px;
  font-size: 13px;
  line-height: 20px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 支付区域 */
.payment-section {
  display: flex;
  gap: 30px;
  padding: 20px 50px;
  margin-bottom: 20px;
}

.qrcode-box {
  width: 150px;
  height: 150px;
  background-color: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(234, 117, 47, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .qrcode-placeholder {
    width: 124px;
    height: 124px;
  }
  .qrcode-canvas {
    width: 124px;
    height: 124px;
  }
  .qrcode-loading {
    font-size: 13px;
    color: #999999;
  }
  .qrcode-mask {
    position: absolute;
    inset: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 14px 10px;
    background: rgba(255, 255, 255, 0.86);
    border-radius: 10px;
    backdrop-filter: blur(2px);
  }
  .qrcode-mask-title {
    font-size: 13px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 6px;
  }
  .qrcode-mask-text {
    font-size: 12px;
    line-height: 1.5;
    color: #666666;
  }
}

.payment-info {
  height: 150px;
  flex: 1;
  font-size: 14px;
  color: #333333;
  display: flex;
  justify-content: space-between;
  .total-price {
    flex: 1;
    .payment-tag {
      background-color: #ffe1c4;
      border-radius: 4px;
      display: inline-block;
      padding: 5px 12px;
      font-size: 14px;
      color: #ff7607;
      margin-left: 10px;
      &::before {
        content: "";
        position: absolute;
        left: -6px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid #ffe1c4; /* 尖角颜色和背景一致 */
      }
    }
    .payment-tags {
      position: relative;
      margin-left: 20px;
    }
    .price {
      font-size: 30px;
      font-weight: 600;
      display: inline-block;
      margin: 0 6px;
      span {
        font-size: 16px;
      }
    }
  }

  .payment-methods {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    margin: 25px 0 32px;
    .method-item {
      width: 150px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #edf3f8;
      border: solid 1px #d8e2ec;
      padding: 5px;
      cursor: pointer;
      transition: all 0.2s ease;
      .sele {
        width: 16px;
        height: 16px;
        margin-left: 12px;
        opacity: 0;
      }
      .method-icon {
        width: 30px;
        height: 30px;
      }
      &.active {
        border-color: #7ecef4;
        background-color: #f2fbff;
        .sele {
          opacity: 1;
        }
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.56;
      }
    }
  }

  .privacy {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 12px;
    color: #666;
  }

  .payment-auto-tip {
    font-size: 12px;
    line-height: 18px;
    color: #999999;
  }

  .discount {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    .discount-top {
      display: flex;
      align-items: center;
      color: #ff7301;
      font-size: 16px;
      font-weight: 600;
      margin-top: 16px;
      .discount-warn {
        position: relative;
        padding: 6px 14px;
        background-color: #626262;
        color: #ffffff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        margin-left: 14px;
        &::before {
          content: "";
          position: absolute;
          left: -6px;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-right: 6px solid #666666; /* 尖角颜色和背景一致 */
        }
      }
    }
    .discount-tag {
      margin-top: 36px;
      width: 390px;
      height: 74px;
      background-image: url("@/assets/image/quan1.png");
      border-radius: 12px;
      display: flex;
      color: #ffffff;
      .left {
        width: 110px;
        height: 74px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        gap: 8px;
        .tag-title {
          font-size: 13px;
        }
        .tag-price {
          font-size: 26px;
          span {
            font-size: 16px;
          }
        }
        &.expired {
          opacity: 0.72;
          filter: grayscale(1);
        }
      }
      .right {
        flex: 1;
        height: 74px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        gap: 8px;
        font-size: 13px;
        &.expired {
          opacity: 0.72;
          filter: grayscale(1);
        }
      }
      .promo-card-main {
        .tag-title {
          font-size: 13px;
        }
        .tag-price {
          font-size: 26px;
          span {
            font-size: 16px;
          }
        }
      }
    }
    .discount-tag2 {
      background-image: url("@/assets/image/quan2.png");
      width: 278px;
    }
  }
}

/* 底部说明 */
.footer-note {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  margin: 17px 50px;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    gap: 4px;
    span {
      color: #f58914;
    }
  }
}
</style>
